const motivos_faltas = [
  {
    codigo: "1a",
    descricao: "Doença/problemas físicos",
    grupo: "Tratamento de doença e de atenção à saúde do estudante",
  },
  {
    codigo: "1b",
    descricao: "Problemas/transtornos psicológicos/mentais",
    grupo: "Tratamento de doença e de atenção à saúde do estudante",
  },
  {
    codigo: "1c",
    descricao: "Pós-parto/Pré-natal/TPM",
    grupo: "Tratamento de doença e de atenção à saúde do estudante",
  },
  {
    codigo: "1d",
    descricao: "Consultas de rotina/tratamento odontológico",
    grupo: "Tratamento de doença e de atenção à saúde do estudante",
  },
  {
    codigo: "2a",
    descricao: "Doença de pessoa da família prejudicando a frequência do estudante à escola",
    grupo: "Doença/óbito na família",
  },
  {
    codigo: "2b",
    descricao: "Óbito de pessoa da família prejudicando a frequência do estudante à escola",
    grupo: "Doença/óbito na família",
  },
  {
    codigo: "3a",
    descricao: "Enchente",
    grupo: "Fatos que impedem o deslocamento/acesso do estudante à escola",
  },
  {
    codigo: "3b",
    descricao: "Falta de transporte",
    grupo: "Fatos que impedem o deslocamento/acesso do estudante à escola",
  },
  {
    codigo: "3c",
    descricao: "Estradas intransitáveis",
    grupo: "Fatos que impedem o deslocamento/acesso do estudante à escola",
  },
  {
    codigo: "3d",
    descricao: "Violência na área onde mora/no trajeto para a escola",
    grupo: "Fatos que impedem o deslocamento/acesso do estudante à escola",
  },
  {
    codigo: "3e",
    descricao: "Inexistência de pessoa para levar à escola",
    grupo: "Fatos que impedem o deslocamento/acesso do estudante à escola",
  },
  {
    codigo: "3f",
    descricao: "Grande distância entre a residência e a escola",
    grupo: "Fatos que impedem o deslocamento/acesso do estudante à escola",
  },
  {
    codigo: "3g",
    descricao: "Outro",
    grupo: "Fatos que impedem o deslocamento/acesso do estudante à escola",
  },
  {
    codigo: "4a",
    descricao: "Com tarefas domiciliares",
    grupo: "Suspensão escolar",
  },
  {
    codigo: "4b",
    descricao: "Sem tarefas domiciliares",
    grupo: "Suspensão escolar",
  },
  {
    codigo: "5a",
    descricao: "Considerada atividade escolar",
    grupo: "Participação em atividade extraclasse/atividades híbridas (semipresenciais)",
  },
  {
    codigo: "5b",
    descricao: "Não é considerada como atividade escolar",
    grupo: "Participação em atividade extraclasse/atividades híbridas (semipresenciais)",
  },
  {
    codigo: "6a",
    descricao: "Preconceito/Discriminação no ambiente escolar/bullying",
    grupo: "Preconceito/Discriminação no ambiente escolar/bullying",
  },
  {
    codigo: "7a",
    descricao: "Indígenas",
    grupo: "Ausência às aulas por respeito às questões sociais, culturais, étnicas ou religiosas",
  },
  {
    codigo: "7b",
    descricao: "Quilombolas",
    grupo: "Ausência às aulas por respeito às questões sociais, culturais, étnicas ou religiosas",
  },
  {
    codigo: "7c",
    descricao: "Circenses",
    grupo: "Ausência às aulas por respeito às questões sociais, culturais, étnicas ou religiosas",
  },
  {
    codigo: "7d",
    descricao: "Ciganos",
    grupo: "Ausência às aulas por respeito às questões sociais, culturais, étnicas ou religiosas",
  },
  {
    codigo: "7e",
    descricao: "Questões religiosas",
    grupo: "Ausência às aulas por respeito às questões sociais, culturais, étnicas ou religiosas",
  },
  {
    codigo: "7f",
    descricao: "Outra",
    grupo: "Ausência às aulas por respeito às questões sociais, culturais, étnicas ou religiosas",
  },
  {
    codigo: "8a",
    descricao: "Gravidez de risco",
    grupo: "Gravidez",
  },
  {
    codigo: "8b",
    descricao: "Não é gravidez de risco",
    grupo: "Gravidez",
  },
  {
    codigo: "9",
    descricao: "Situação de rua",
    grupo: "Situação de rua",
  },
  {
    codigo: "10a",
    descricao: "A escola sabe que o estudante conta com atenção da rede de proteção local",
    grupo: "Trabalho infantil",
  },
  {
    codigo: "10b",
    descricao: "A escola não sabe se o estudante conta com atenção da rede de proteção local",
    grupo: "Trabalho infantil",
  },
  {
    codigo: "11a",
    descricao: "Violência no ambiente escolar",
    grupo: "Violência no ambiente escolar",
  },
  {
    codigo: "12a",
    descricao: "Emprego formal (a partir de 16 anos)",
    grupo: "Trabalho do Adolescente",
  },
  {
    codigo: "12b",
    descricao: "Estagiário",
    grupo: "Trabalho do Adolescente",
  },
  {
    codigo: "12c",
    descricao: "Trabalho informal",
    grupo: "Trabalho do Adolescente",
  },
  {
    codigo: "12d",
    descricao: "Menor aprendiz",
    grupo: "Trabalho do Adolescente",
  },
  {
    codigo: "13a",
    descricao: "Exploração/Abuso Sexual",
    grupo: "Exploração/Abuso Sexual",
  },
  {
    codigo: "14a",
    descricao: "Desinteresse/Desmotivação pelos estudos",
    grupo: "Desinteresse/Desmotivação pelos estudos",
  },
  {
    codigo: "15a",
    descricao: "Abandono Escolar/Desistência",
    grupo: "Abandono Escolar/Desistência",
  },
  {
    codigo: "16a",
    descricao: "Separação dos pais",
    grupo: "Questões socioeconômicas, educacionais e/ou familiares",
  },
  {
    codigo: "16b",
    descricao: "Necessidade de cuidar de familiares (idoso, criança, pessoa com deficiência)",
    grupo: "Questões socioeconômicas, educacionais e/ou familiares",
  },
  {
    codigo: "16c",
    descricao: "Viagem com a família (trabalho sazonal/agricultura temporária/colheita/outros)",
    grupo: "Questões socioeconômicas, educacionais e/ou familiares",
  },
  {
    codigo: "16d",
    descricao: "Casamento do(a) Estudante",
    grupo: "Questões socioeconômicas, educacionais e/ou familiares",
  },
  {
    codigo: "16e",
    descricao: "Falta de uniforme/calcado/roupa adequada",
    grupo: "Questões socioeconômicas, educacionais e/ou familiares",
  },
  {
    codigo: "16f",
    descricao: "Pais sem domínio dos filhos/relação familiar precária",
    grupo: "Questões socioeconômicas, educacionais e/ou familiares",
  },
  {
    codigo: "16g",
    descricao: "Família desconhece as faltas do estudante às aulas",
    grupo: "Questões socioeconômicas, educacionais e/ou familiares",
  },
  {
    codigo: "16h",
    descricao: "Negligência dos pais ou responsáveis",
    grupo: "Questões socioeconômicas, educacionais e/ou familiares",
  },
  {
    codigo: "16i",
    descricao:
      "Estudantes com deficiência, transtornos globais do desenvolvimento e altas habilidades ou superdotação sem apoio/estimulação para permanecer na escola",
    grupo: "Questões socioeconômicas, educacionais e/ou familiares",
  },
  {
    codigo: "16j",
    descricao: "A escola não possui tradutor e intérprete de Libras para estudantes surdos",
    grupo: "Questões socioeconômicas, educacionais e/ou familiares",
  },
  {
    codigo: "17a",
    descricao: "Envolvimento com drogas",
    grupo: "Envolvimento com drogas",
  },
  {
    codigo: "18a",
    descricao: "Envolvimento em atos infracionais",
    grupo: "Envolvimento em atos infracionais",
  },
  {
    codigo: "19a",
    descricao: "Violência Intrafamiliar",
    grupo: "Violência Intrafamiliar",
  },
  {
    codigo: "20a",
    descricao: "Greve",
    grupo: "Situação coletiva que impede a escola de receber seus estudantes",
  },
  {
    codigo: "20b",
    descricao: "Calamidade pública que atingiu a escola ou exigiu o uso do espaço como abrigamento",
    grupo: "Situação coletiva que impede a escola de receber seus estudantes",
  },
  {
    codigo: "20c",
    descricao: "Escola sem professor",
    grupo: "Situação coletiva que impede a escola de receber seus estudantes",
  },
  {
    codigo: "20d",
    descricao: "Reforma geral da escola",
    grupo: "Situação coletiva que impede a escola de receber seus estudantes",
  },
  {
    codigo: "20e",
    descricao: "Escola fechada por situação de violência",
    grupo: "Situação coletiva que impede a escola de receber seus estudantes",
  },
  {
    codigo: "20f",
    descricao: "Falta de merenda escolar",
    grupo: "Situação coletiva que impede a escola de receber seus estudantes",
  },
  {
    codigo: "20g",
    descricao: "Outros",
    grupo: "Situação coletiva que impede a escola de receber seus estudantes",
  },
  {
    codigo: "20h",
    descricao: "Férias",
    grupo: "Situação coletiva que impede a escola de receber seus estudantes",
  },
  {
    codigo: "21a",
    descricao: "Estudante Concluiu o Ensino Médio",
    grupo: "Estudante Concluiu o Ensino Médio",
  },
  {
    codigo: "22a",
    descricao: "Óbito do estudante",
    grupo: "Óbito do estudante",
  },
  {
    codigo: "23a",
    descricao: "Com acompanhamento regular",
    grupo: "EJA Semipresencial",
  },
  {
    codigo: "23b",
    descricao: "Sem acompanhamento regular",
    grupo: "EJA Semipresencial",
  },
  {
    codigo: "24a",
    descricao: "A escola não sabe/não informou o motivo",
    grupo: "Outros",
  },
  {
    codigo: "24b",
    descricao: "Não foi identificado motivo adequado nesta lista",
    grupo: "Outros",
  },
  {
    codigo: "25a",
    descricao: "Inexistência de educação infantil no território em que mora",
    grupo: "Problemas na oferta de serviços educacionais",
  },
  {
    codigo: "25b",
    descricao: "Inexistência de ensino fundamental no território em que mora",
    grupo: "Problemas na oferta de serviços educacionais",
  },
  {
    codigo: "25c",
    descricao: "Inexistência de ensino médio no território onde mora",
    grupo: "Problemas na oferta de serviços educacionais",
  },
  {
    codigo: "25d",
    descricao: "Inexistência de serviços educacionais para acampados/ciganos/circenses/itinerantes",
    grupo: "Problemas na oferta de serviços educacionais",
  },
  {
    codigo: "25e",
    descricao:
      "Inexistência de serviços educacionais em situação de internação/privação de liberdade",
    grupo: "Problemas na oferta de serviços educacionais",
  },
  {
    codigo: "25f",
    descricao: "Inexistência de escola indígena no território onde mora",
    grupo: "Problemas na oferta de serviços educacionais",
  },
  {
    codigo: "25g",
    descricao: "Falta de vaga na escola para a etapa de ensino do estudante",
    grupo: "Problemas na oferta de serviços educacionais",
  },
  {
    codigo: "25h",
    descricao:
      "Concluiu a educação infantil/ensino fundamental/EJA e inexiste oferta imediata da etapa seguinte",
    grupo: "Problemas na oferta de serviços educacionais",
  },
  {
    codigo: "26a",
    descricao: "Inexistência de educação especial de estudantes com deficiência",
    grupo: "Educação bilíngue de surdos e educação especial",
  },
  {
    codigo: "26b",
    descricao:
      "Inexistência de transporte/de gratuidade/transporte acessível à escola para beneficiário com deficiência, transtornos globais do desenvolvimento e altas habilidades ou superdotação",
    grupo: "Educação bilíngue de surdos e educação especial",
  },
  {
    codigo: "26c",
    descricao:
      "Beneficiário com deficiência, transtornos globais do desenvolvimento e altas habilidades ou superdotação não frequenta a escola por resistência injustificada da família",
    grupo: "Educação bilíngue de surdos e educação especial",
  },
  {
    codigo: "26d",
    descricao:
      "Inexistência de acessibilidade física/sensorial/metodológica no ambiente escolar para o beneficiário com deficiência, transtornos globais do desenvolvimento e altas habilidades ou superdotação",
    grupo: "Educação bilíngue de surdos e educação especial",
  },
  {
    codigo: "26e",
    descricao:
      "A escola alega não possuir vaga para estudantes com deficiência, transtornos globais do desenvolvimento e altas habilidades ou superdotação",
    grupo: "Educação bilíngue de surdos e educação especial",
  },
  {
    codigo: "26f",
    descricao:
      "Inexistência de escola (ou de vaga em escola) com tradutor e intérprete de Libras para estudantes surdos",
    grupo: "Educação bilíngue de surdos e educação especial",
  },
  {
    codigo: "26g",
    descricao:
      "Beneficiário com deficiência, transtornos globais do desenvolvimento e altas habilidades ou superdotação apresenta impedimento de longo prazo de natureza física, mental, intelectual ou sensorial que não permite a frequência escolar",
    grupo: "Educação bilíngue de surdos e educação especial",
  },
  {
    codigo: "27a",
    descricao:
      "Beneficiário sem vínculo/matrícula escolar foi encontrado, mas não quer mais estudar",
    grupo: "Outras situações específicas",
  },
  {
    codigo: "27b",
    descricao: "Estudante concluiu o Ensino Médio",
    grupo: "Outras situações específicas",
  },
  {
    codigo: "27c",
    descricao: "Óbito do estudante",
    grupo: "Outras situações específicas",
  },
  {
    codigo: "27d",
    descricao:
      "Transferência em andamento/pendente permanecendo sem solução/aceite, após o encerramento de 02 (dois) períodos de coleta, o beneficiário será lançado como Não Localizado no município de origem do Cadastro Único da família",
    grupo: "Outras situações específicas",
  },
  {
    codigo: "27e",
    descricao:
      "Beneficiário com dados errados impedindo a identificação pela escola (nome errado/data de nascimento errada/NIS duplicado)",
    grupo: "Outras situações específicas",
  },
];

export default motivos_faltas;
